import { gql } from '@apollo/client'

import { getQueryService } from '../../../../helpers/GraphqlHelpers'
import { PageBySlugQuery } from '../../../generated/graphql'

export const pageBySlug = getQueryService({
  query: gql`
    query pageBySlug($slug: String!) {
      pageBySlug(slug: $slug) {
        id
        name
        slug
        content
        image
        image_alt
        video
        media_position
      }
    }
  `,
  transformer: (response: PageBySlugQuery) => {
    return response.pageBySlug
  },
})
